import { Input } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setName } from '../../actions/newAnswer/nameActions';
import { getFirstName } from '../../selectors/user';
import { Name } from '../../components/NewAnswer/parts/Name';
import { getName } from '../../selectors/newAnswer';

export const NameContainer = (): React.JSX.Element => {
  const initialName = useSelector(getFirstName);
  const name = useSelector(getName) || initialName;
  const dispatch = useDispatch();

  const onNameChange = React.useCallback(
    /* oxlint-disable-next-line typescript/no-unused-vars, typescript/no-explicit-any */
    (e: React.ChangeEvent<HTMLInputElement>, _value: any) => {
      dispatch(setName(e.currentTarget.value));
    },
    [dispatch],
  );

  return (
    <Name
      title="Имя"
      name={
        <Input
          size="M"
          width="100%"
          inline={true}
          onChange={onNameChange}
          placeholder="Например, Иван"
          value={name}
          disabled={!!initialName}
        />
      }
    />
  );
};
